var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch1X(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icons/search"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4801 4C8.24409 4 4 8.24328 4 13.479C4 18.7148 8.24409 22.958 13.4801 22.958C15.4712 22.958 17.3188 22.3442 18.8442 21.2955L25.8009 28.2522L25.9132 28.3523C26.4189 28.7527 27.1555 28.7194 27.6227 28.2522C28.1258 27.7492 28.1258 26.9335 27.6227 26.4304L20.7521 19.5599C22.1298 17.914 22.9592 15.7935 22.9592 13.479C22.9592 8.24348 18.7153 4 13.4801 4ZM13.4801 6.57643C17.2924 6.57643 20.3827 9.66646 20.3827 13.479C20.3827 17.2916 17.2924 20.3816 13.4801 20.3816C9.6669 20.3816 6.57643 17.2917 6.57643 13.479C6.57643 9.66632 9.6669 6.57643 13.4801 6.57643Z",
    fill: "#DB7940"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_3339",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Combined Shape_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4801 4C8.24409 4 4 8.24328 4 13.479C4 18.7148 8.24409 22.958 13.4801 22.958C15.4712 22.958 17.3188 22.3442 18.8442 21.2955L25.8009 28.2522L25.9132 28.3523C26.4189 28.7527 27.1555 28.7194 27.6227 28.2522C28.1258 27.7492 28.1258 26.9335 27.6227 26.4304L20.7521 19.5599C22.1298 17.914 22.9592 15.7935 22.9592 13.479C22.9592 8.24348 18.7153 4 13.4801 4ZM13.4801 6.57643C17.2924 6.57643 20.3827 9.66646 20.3827 13.479C20.3827 17.2916 17.2924 20.3816 13.4801 20.3816C9.6669 20.3816 6.57643 17.2917 6.57643 13.479C6.57643 9.66632 9.6669 6.57643 13.4801 6.57643Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_3339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/secondary/lightCyan+75 Copy"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle Copy 7",
    width: 32,
    height: 32,
    fill: "#DB7940"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1X);
export default __webpack_public_path__ + "static/media/search@1x.5fd80e0ae9e0576b6b016a25b36b642e.svg";
export { ForwardRef as ReactComponent };